module.exports = __webpack_public_path__ + "img/hero_1.091a0177.webp";